import escapeRegExp from "./escapeRegExp.js";

export default (search) => {
  return new RegExp(escapeRegExp(`${search || ""}`), "i");
};
